import type { ReactNode } from 'react'
import React from 'react'

import useBreakpoints from '../../../hooks/useBreakpoints'
import { StyledPageContent } from './PageContent.styles'

export interface PageContentProps {
  'data-e2e'?: string
  children?: ReactNode
  className?: string
}

const PageContent = ({ 'data-e2e': dataE2e, children, className }: PageContentProps) => {
  const { isMobile, isTablet } = useBreakpoints()

  return (
    <StyledPageContent
      className={className}
      data-e2e={dataE2e}
      isAlongsideBurgerMenu={isMobile || isTablet}
    >
      {children}
    </StyledPageContent>
  )
}

export default PageContent
